import { render } from "./RolePermissionManagement.vue?vue&type=template&id=e51c84be&scoped=true"
import script from "./RolePermissionManagement.vue?vue&type=script&lang=js"
export * from "./RolePermissionManagement.vue?vue&type=script&lang=js"

import "./RolePermissionManagement.vue?vue&type=style&index=0&id=e51c84be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e51c84be"]])

export default __exports__